import { render, staticRenderFns } from "./ComboboxTerritorioIniciativaStatus.vue?vue&type=template&id=3f0015da"
import script from "./ComboboxTerritorioIniciativaStatus.vue?vue&type=script&lang=js"
export * from "./ComboboxTerritorioIniciativaStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports